import React from "react";
import classes from "./ToggleNav.module.css";

function ToggleNav(props) {
  return (
    <div className={classes.ToggleNav}>
      <button className={classes.ToggleNavOpen} onClick={props.openModal}>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
      </button>
    </div>
  );
}

export default ToggleNav;
